import { render, staticRenderFns } from "./HomeNewsList.vue?vue&type=template&id=25ea070f&scoped=true"
import script from "./HomeNewsList.vue?vue&type=script&lang=js"
export * from "./HomeNewsList.vue?vue&type=script&lang=js"
import style0 from "./HomeNewsList.vue?vue&type=style&index=0&id=25ea070f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ea070f",
  null
  
)

export default component.exports